import React, {ReactElement, useState} from "react";
import {PAGE_FRAGMENT_XXXLG_WIDTH, PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {CallOutlined, MenuOutlined} from "@mui/icons-material";
import {StyledBoxRow} from "@/shared/StyledComponents";
import {HeaderSectionData} from "../../types";
import Typography from "@mui/material/Typography";

export function HeaderSection(props: { data: HeaderSectionData, pathname?: string }): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  return <div style={{
    zIndex: 1000,
    background: theme.palette.background.paper,
    borderBottom: `4px solid ${theme.palette.secondary.main}`,
  }}>
    <div style={{
      display: "flex",
      alignItems: "center",
      padding: `0 ${PD_LG}px`,
      height: 72,
      width: "100%",
      maxWidth: PAGE_FRAGMENT_XXXLG_WIDTH,
      margin: "auto",
    }}>
      <a href="/" style={{height: "84%"}}>
        <StyledBoxRow style={{height: "100%", alignItems: "center", gap: PD_SM, flexShrink: 0}}>
          <img src={props.data.logo} style={{height: "100%", objectFit: "contain"}}/>
          {md && props.data.name
            ? <Typography style={{maxWidth: 240, flexShrink: 0, lineHeight: 1.1, fontWeight: "bold"}}>
              {props.data.name}
            </Typography>
            : null}
        </StyledBoxRow>
      </a>

      <div style={{flexGrow: 1}}/>

      {md && props.data.links?.length > 0
        ? <StyledBoxRow style={{height: "100%", gap: PD_MD / 2, marginRight: PD_MD}}>
          {props.data.links.map((link, i) => {
            const active = props.pathname === link.url;
            return <Button
              key={i}
              href={link.url}
              style={{
                color: active ? theme.palette.secondary.main : null,
                fontWeight: active ? "700" : "400",
                borderBottom: active ? `4px solid ${theme.palette.secondary.main}` : "4px solid transparent",
                borderRadius: 0,
                paddingBottom: PD_SM / 2,
              }}>
              {link.text}
            </Button>;
          })}
        </StyledBoxRow>
        : null}

      {props.data.phone
        ? <Button
          href={`tel:${props.data.phone}`}
          startIcon={<CallOutlined/>}
          variant="contained"
          style={{height: 44, flexShrink: 0}}>
          {props.data.phone}
        </Button>
        : null}

      {!md && props.data.links?.length > 0
        ? <IconButton onClick={() => setDrawerOpen(true)} style={{marginLeft: PD_SM, color: "#fff"}}>
          <MenuOutlined/>
        </IconButton>
        : null}
    </div>

    <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
      <List style={{width: 240, paddingTop: PD_LG}}>
        {props.data.links?.map((link, i) => {
          const active = props.pathname === link.url;
          return <ListItem key={i} disablePadding>
            <ListItemButton
              component="a"
              href={link.url}
              selected={active}
              onClick={() => setDrawerOpen(false)}>
              <ListItemText
                primary={link.text}
                primaryTypographyProps={{fontWeight: active ? "700" : "normal"}}/>
            </ListItemButton>
          </ListItem>;
        })}
      </List>
    </Drawer>
  </div>;
}
